import angular from "angular";

angular
    .module('app')
    .component('categoryImageSelect', {
        template: require('./category-image-select.html'),
        controller: ['$document', '$timeout', controller]
    });

function controller($document, $timeout) {

    let $ctrl = this;

    $ctrl.image = null;

    $ctrl.$onInit = function () {
    };

    $ctrl.imageSelected = function () {
        console.log($ctrl.image);
    };

}
